export default {
  author: "Selby Baidjnath",
  hero: {
    subtitle: "Fullstack Software Engineer",
    description: "Building reliable and scalable systems by day. Leveraging technology to launch fully featured products by night. ",
    cta: "Contact me",
  },
  products: {
    featured: [
      {
        name: "Launchwise",
        medium: "Dart, Python, SQL",
        summary: "The Thinkwise Launch, deploy and usage statistics client for ERP Thinkwise",}
        // ,
        // copy: [
          // "See millions of messages at a glance, without data leaving your computer."
        // ],
      //   links: {
      //     color: "#363636",
      //     primary: {
      //       name: "Discover",
      //       url: "https://doubletext.me/"
      //     }
      //   },
      //   images: [
      //     "/doubletext/0.jpg",
      //     "/doubletext/1.jpg",
      //     "/doubletext/2.jpg",
      //     "/doubletext/3.jpg",
      //     "/doubletext/4.jpg"
      //   ]
      // },
      // {
      //   name: "ClimbList",
      //   medium: "React · Next.js",
      //   summary: "Construction is now in progress.",
      //   copy: [
      //     "Compare and track grades between gyms around the country.",
      //   ],
      //   links: {
      //     color: "#363636",
      //     primary: {
      //       name: "Learn more",
      //       url: "https://climblist.com/"
      //     }
      //   },
      //   images: [
      //     "/climblist/0.jpg",
      //     "/climblist/1.jpg",
      //   ]
      // }
    ],
    // Only supports 0-3 at the moment
    minor: [
      // {
      //   name: "Volunteer Portal",
      //   description: "Find and track volunteer opportunities.",
      //   link: {
      //     name: "Github",
      //     url: "https://github.com/zendesk/volunteer_portal"
      //   }
      // },
      {
        name: "Grove's Life",
        description: "Created in 72 hours in a team for the Unity GameJam.",
        link: {
          name: "Play",
          url: "https://ericjdeveloper.itch.io/groves-life"
        }
      },
      {
        name: "Crimson",
        description: "Administrative discord bot that serves over 3000 users",
        link: {
          name: "Invite",
          url: "https://discord.com/oauth2/authorize?client_id=496832675001401354&scope=bot&permissions=8"
        }
      }
    ]
  },
  logoSection: {
    title: "As hired by",
    // Only supports 0-3 at the moment
    logos: [
      {
        src: "/logos/apptastic.svg",
        url: "https://apptastic.sr/",
        alt: "Apptastic"
      },
      {
        src: "/logos/itp.svg",
        url: "https://itpartner.nl/",
        alt: "IT Partner BV"
      },
      {
        src: "/logos/vshtech.svg",
        url: "https://www.vsh-tech.com/",
        alt: "VSH Tech BV"
      }
  ]
  },
  footer: {
    tagline: "Selby Baidjnath — Paramaribo, Suriname",
    links: [
      {
        name: "Github",
        url: "https://github.com/ultimaterex",
        fa: "fab fa-github"
      },
      {
        name: "Linkedin",
        url: "https://www.linkedin.com/in/selbybaidjnath/",
        fa: "fab fa-linkedin"
      },
      {
        name: "Email",
        url: "mailto:contact@serubii.com",
        fa: "fa fa-envelope"
      },
    ]
  }
}
